<template>
  <v-snackbar :color='snackType' v-model='show' right :timeout=3000>
    {{ msg }}
    <v-btn text :color="closeColor" @click='close'>{{ closeText }}</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'wc-snackbar',
  props: {
    value: {
      required: true
    },
    msg: {
      required: false,
      default: 'Hello!'
    },
    snackType: {
      required: false,
      default: 'info'
    },
    closeColor: {
      required: false,
      default: ''
    },
    closeText: {
      required: false,
      default: 'Close'
    }
  },
  data () {
    return {
      show: false
    }
  },
  watch: {
    value: function () {
      this.show = this.value
    }
  },
  methods: {
    close () {
      this.show = false
      this.$emit('close')
    }
  }
}
</script>
